import { APIFetch } from '../../fetch.js';

export const requirementConfirmed = async ({ token, requirementId }) => {
  const response = await APIFetch({
    route: 'requirements/requirementConfirmed',
    method: 'POST',
    authToken: token,
    body: {
      requirementId,
    },
  });

  if (!response.ok) {
    console.error(await response.text());
    throw new Error('An error occured during RequirementConfirmed request!');
  }

  if (response.status === 200) {
    return await response.json();
  }

  return null;
};
